//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const DeveloperInvestmentsProposedWidget = ({ count }: { count: number }) => {
  return <StatCard title='Developer Investments Proposed' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default DeveloperInvestmentsProposedWidget;
